import {inject, Injectable} from '@angular/core';
import {environment} from '@environments/environment.prod';
import {map, Observable} from 'rxjs';
import {
  ListPersonTypesUseCasePort
} from '@features/setting/application/use_cases/list-person-types/list-person-types.use-case.port';
import {
  ListPersonTypesPayloadDto
} from '@features/setting/application/use_cases/list-person-types/dto/list-person-types.payload.dto';
import {
  ListPersonTypesResponseDto
} from '@features/setting/application/use_cases/list-person-types/dto/list-person-types.response.dto';
import {ClientHttpPort} from '@shared/application/ports/http/client.http.port';
import {LocalStoragePort} from '@shared/application/ports/storage/local.storage.port';
import {NavigationPort} from '@shared/application/ports/navigation/navigation.port';
import {
  ListPersonTypesHttpPayloadDto
} from '@features/setting/infrastructure/http/list-person-types/list-person-types.http.payload.dto';
import {
  ListPersonTypesHttpResponseDto
} from '@features/setting/infrastructure/http/list-person-types/list-person-types.http.response.dto';
import {
  ListPersonTypesHttpMapper
} from '@features/setting/infrastructure/http/list-person-types/list-person-types.http.mapper';
import {FilterInterface} from '@core/interfaces/filter/filter.interface';
import {HttpHeaders} from '@angular/common/http';

@Injectable()
export class ListPersonTypesHttpAdapter implements ListPersonTypesUseCasePort {

  private readonly url = environment.uri;
  private readonly http = inject(ClientHttpPort);
  private readonly localStoragePort = inject(LocalStoragePort);
  private readonly navigationPort = inject(NavigationPort);

  public execute(payload: ListPersonTypesPayloadDto): Observable<ListPersonTypesResponseDto> {
    const url = window.location.href;
    const {suffix} = this.navigationPort.extractQueryParams(url);
    let suffixDatabase: string | null = null;
    if (!suffix) {
      suffixDatabase = this.localStoragePort.getByKey<string | null>('_suffix');
      if (!suffixDatabase) throw new Error(`Could not find suffix`);
    } else {
      suffixDatabase = suffix;
    }
    const filter: FilterInterface = {};
    const headers: HttpHeaders = new HttpHeaders({
      "token": environment.secret_key,
      "x-filter-model": JSON.stringify(filter),
    });
    return this.http.get<ListPersonTypesHttpResponseDto>(`${this.url}person-type-list?suffix_database=${suffixDatabase}`, {headers})
      .pipe(
        map(ListPersonTypesHttpMapper.toResponse)
      )
  }

}
